export default __webpack_public_path__ + "assets/7eefd0595885e160466a2190fe6614ff.jpg";